<template>
  <v-timeline-item
      class="mb-1"
      small
      fill-dot
      color="primary"
    >
      <div class="d-flex justify-space-between flex-grow-1">
        <div>
          <v-chip
            class="ms-0"
            color="primary"
            label
            small
          >
            {{i18n[item.update.split('|')[0]] ? i18n[item.update.split('|')[0]] : item.update.split('|')[0]}}
          </v-chip>
          <span v-if="item.update.split('|')[0] === 'purchase_order_payment_method_id'">
            <div>
              {{payment_methods.filter(x=>x.id == item.update.split('|')[1]).length ? payment_methods.filter(x=>x.id == item.update.split('|')[1])[0].text : ''}}
            </div>
            <div>
              {{payment_methods.filter(x=>x.id == item.update.split('|')[2]).length ? payment_methods.filter(x=>x.id == item.update.split('|')[2])[0].text : ''}}
            </div>
          </span>
          <span v-else-if="item.update.split('|')[0] === 'wholesale_status_id'">
            <div>
              {{statuses.filter(x=>x.id == item.update.split('|')[1]).length ? statuses.filter(x=>x.id == item.update.split('|')[1])[0].text : ''}}
            </div>
            <div>
              {{statuses.filter(x=>x.id == item.update.split('|')[2]).length ? statuses.filter(x=>x.id == item.update.split('|')[2])[0].text : ''}}
            </div>
          </span>
          <span v-else-if="item.update.split('|')[0] === 'payment_attachment_url'">
            <v-btn :href="item.update.split('|')[1]" target="_blank" class="mr-2" color="blue" dark
              x-small>
              <v-icon size="small" class="ml-1">open_in_new</v-icon>
              {{i18n["proof_of_payment"]}}
            </v-btn>
          </span>
          <span v-else>

            <div>{{item.update.split('|')[1]}}</div>
            <div>{{item.update.split('|')[2]}}</div>
          </span>
        </div>
        <div class="flex-shrink-0 text-left">
          <div>
            <v-chip x-small label color="secondary">
              {{item.created_at.split('.')[0].split('T')[0]}}
            </v-chip>
            
          </div>
          <div>
            <small>
              {{item.created_at.split('.')[0].split('T')[1]}}
            </small>
          </div>
          <v-chip x-small label v-if="item.user && item.user.name && master">
            {{item.user.name}}
          </v-chip>
          <v-chip x-small label v-else>
            NINJA SYSTEMS
          </v-chip>
        </div>
      </div>
    </v-timeline-item>
</template>

<script>
export default {
  props:['item', 'payment_methods', 'statuses'],
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
    master() {
      return this.$store.state.user.role == 'master';
    },
  },

}
</script>

<style>

</style>